module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAAAXNSR0IArs4c6QAAAVJJREFUOBGllL9LQlEUx9+VlkSJahZBxEEabGjMNRqqqbXJ/8CxhhqDWmoLhf6D1KFobA9aGltqiCCoIUNC6PU5z3cvp8fzx9MDH8/3/IR73/MZT5nv+0eEayoVlT0St9AwxvxGi8YmWJRDv8A9vNt8xJeJ89CGXRb2I/VByLIiiG3GNpCkdhZ0DH5auJTu/RfowhD9pfI76JqKvTkdTKDPw54sfhs24CLMJVvGHb0xuC/DHLGImxdtLekx7VysT8klwhbVg9iO0ckys4dQkDaDOMHX1Yxc6p2Kh8kmhSp0QY5bkmUfiEWYxh4ZWoVPOJU7m3YRo568xA+QgaVZH4DMr0Bgsy6zewIf99ImfQBuoSw7hjQswB688nI+4UcaD+6bhmfohI03boDi2D+6a0bQfy3onNMUlqEPSezSLUC475kk2bKOq4iewH7oueJK3LfvD5R8qX3Oym5LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-print.png
// module id = 1406
// module chunks = 0